// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { addToChainAfter, addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchBeginLoadProduct,
    LoadRealTimeInventory,
    LoadRealTimePrices,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { shouldSkipRealTimeCall } from "@tps/XDL/Utilities";

/* 
    XNG-Changes: TPS-1063: 
    Added a loader to ensure the product data is fully loaded before rendering.
    This fixes an issue where the UI initially showed the "no stock" call-to-branch
    message due to incomplete product/variant data, and then updated again once the
    stocked variant became available. By loading the product first, we prevent the
    incorrect out-of-stock state from appearing.
*/
export const XngDispatchBeginLoadProduct: typeof DispatchBeginLoadProduct = props => {
    if (props.parameter.path) {
        props.dispatch({
            type: "xProductDetails/isProductLoading",
            isProductLoading: true,
            productPath: props.parameter.path,
        } as any);
    }
};

export const XngDispatchCompleteLoadProduct: typeof DispatchBeginLoadProduct = async props => {
    if (!getIsWebCrawler()) {
        const checkData = () => {
            return !!props.pricingLoaded && !!props.inventoryLoaded;
        };
        await waitFor(checkData);
    }
    props.dispatch({
        type: "xProductDetails/isProductLoading",
        isProductLoading: false,
        productPath: props.parameter.path,
    } as any);
};

// <xng-changes> : TPS-1132
export const XngLoadRealTimePrices: typeof LoadRealTimePrices = props => {
    if (shouldSkipRealTimeCall(props)) {
        props.pricingLoaded = true;
        return;
    }
    LoadRealTimePrices(props);
};

export const XngLoadRealTimeInventory: typeof LoadRealTimeInventory = props => {
    if (shouldSkipRealTimeCall(props)) {
        props.inventoryLoaded = true;
        return;
    }
    LoadRealTimeInventory(props);
};
// </xng-changes>

addToChainAfter(chain, DispatchBeginLoadProduct, XngDispatchBeginLoadProduct);
addToEndOfChain(chain, XngDispatchCompleteLoadProduct);
replaceInChain(chain, LoadRealTimePrices, XngLoadRealTimePrices);
replaceInChain(chain, LoadRealTimeInventory, XngLoadRealTimeInventory);
